import { usePlanContext } from "../../auth/planProvider/PlanProvider";
import { useUserContext } from "../../auth/userContextProvider/UserContextProvider";

export interface AiFeatureAccess {
    // The AI add-on is purchased/active for the customer.
    planActivated: boolean;
    // The add-on is active and this user has permission to use AI features.
    canUse: boolean;
    // Render the AI affordance: either the user can use it, or the add-on is missing so we can nudge an upgrade.
    showAffordance: boolean;
    // The AI quality-assurance (best practice) column/menu. The research add-on replaces it, so it hides that affordance.
    showAiQualityAssurance: boolean;
    // The AI quality-assurance feature is genuinely usable (no nudge), used for plain navigation entries.
    canUseAiQualityAssurance: boolean;
}

export function useAiFeatureAccess(): AiFeatureAccess {
    const { addonsFeatures } = usePlanContext();
    const { permissions } = useUserContext();

    const planActivated = addonsFeatures.aiFeatures;
    const canUse = planActivated && permissions.canAccessAiFeature;
    const showAffordance = !planActivated || permissions.canAccessAiFeature;

    return {
        planActivated,
        canUse,
        showAffordance,
        showAiQualityAssurance: showAffordance && !addonsFeatures.research,
        canUseAiQualityAssurance: canUse && !addonsFeatures.research,
    };
}
